import React from 'react'
import getQueryObject from '@helpers/misc/getQueryObject'
import useDebounce from '@hooks/useDebounce'
import SelectProduct from '@page-components/Order/Products/ProductsContent/SelectProduct'
import {useRouter} from 'next/router'

export default function Product(props) {
  const {productId: propsProductId, storeId, menuId, preferences, productCardDesign} = props
  const [debouncedProductId] = useDebounce(propsProductId, 400)
  const router = useRouter()
  const productId = propsProductId || debouncedProductId

  return (
    <SelectProduct
      productCardDesign={productCardDesign}
      product={{_id: productId}}
      storeId={storeId}
      menuId={menuId}
      open={!!propsProductId}
      preferences={preferences}
      close={() => {
        const query = getQueryObject(router)
        delete query.productId
        router.push({pathname: '/pedir', query}, null, {scroll: false})
      }}
    />
  )
}
